import classNames from "classnames";
import React from "react";
import {EmailActions} from "../../actions/EmailActions";
import {useAppDispatch} from "../../hooks/ReduxHooks";

interface CategoryChipProps {
    category: string | null;
    onClick?: () => void;
}

export const CategoryChip = ({category, onClick}: CategoryChipProps) => {
    if (!category) {
        return null;
    }
    const classes = classNames(
        "email-category",
        "category-" + category?.replace(" ", "_"),
        {
            "selectable": !!onClick,
            "pointer": !!onClick
        });
    return (
        <span className={classes}
              onClick={() => onClick ? onClick() : undefined}>
            {category}
        </span>
    );
}

interface EmailCategoryProps {
    category: string | null;
}

export const EmailCategory = ({category}: EmailCategoryProps) => {

    const dispatch = useAppDispatch();

    function onChangeCategory() {
        dispatch(EmailActions.showEmailCategoryDialog(category || ""));
    }

    return <CategoryChip category={category} onClick={onChangeCategory}/>;
}